module.exports = __webpack_public_path__ + "static/img/advantage1.0c58725.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tech/advantage1.png
// module id = hSwb
// module chunks = 11